import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import { getImage } from '../../utils/cutImg';
import { asyncGetPlayNum } from '../../utils/playNumUnit';
import { formatVideoDuration } from '../../utils/timeUnit';
// import { getFeedFlowList } from '../../../../common/api';
// import { handleVideoStream } from '../../utils/videoList';

import { getVideoStream } from '../../../services/api';

import Ad from '@ifeng-fe/ui_pc_ad';

class Content extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
        columnId: PropTypes.string,
    };

    state = {
        initData: [],
        moreData: [],
        pagination: {
            current: 2,
            pageSize: 24,
        },
        showloadMore: true,
        loading: false,
        playNum: new Object(),
    };

    componentDidMount() {
        if (this.props.content) {
            this.initData();
        }
    }

    // 分批获取播放量
    asyncGetPlayNum = async arr => {
        const res = await asyncGetPlayNum(arr);

        this.setState({
            playNum: { ...this.state.playNum, ...res },
        });
    };

    // 获取
    asyncGetVideoStream = async (page, pageSize) => {
        const { columnId } = this.props;

        // const _res = await getFeedFlowList('df', columnId, page, pageSize);
        const _res = await getVideoStream(page, pageSize, columnId, 1);

        // console.log(_res);
        const res = {
            data: [],
            total: 0,
        };

        // if (_res && _res.data) {
        //     res.data = handleVideoStream(_res.data, 1);
        //     res.total = _res.totalPage;
        // }

        return _res.data;
    };

    // 渲染首屏数据
    initData = async () => {
        const { content } = this.props;

        if (content) {
            const initData = content.slice(0, 24);

            this.asyncGetPlayNum(initData);
            this.setState({
                initData,
            });
        }
    };

    // 分页获取新闻数据
    getCustomNewsTfList = async ({ current, pageSize }) => {
        const res = await this.asyncGetVideoStream(current, pageSize);

        const news = res.data || [];

        const result = {
            news,
            total: res.total,
        };

        // console.log(result);

        return result;
    };

    // 点击加载更多
    handleClickLoadMore = async () => {
        console.log('点击加载');
        try {
            this.setState({
                // 每次重置当前页
                // pagination: {
                //     current: this.state.pagination.current + 1,
                //     pageSize: 24,
                // },
                loading: true,
            });
            const req = await this.getCustomNewsTfList(this.state.pagination);

            if (!req.news.length) {
                this.setState({
                    showloadMore: false,
                });

                return;
            }
            const { news, total } = req;

            // 分批获取播放量
            this.asyncGetPlayNum(news);
            // console.log(this.state.moreData);
            const nextNewsData = this.state.moreData;

            nextNewsData.push(...news);

            // 全部加载完成，隐藏按钮
            if (Object.prototype.toString.call(news) === '[object Array]') {
                if (this.state.pagination.current < total) {
                    this.setState(
                        {
                            moreData: nextNewsData,
                            pagination: {
                                current: this.state.pagination.current + 1,
                                pageSize: 24,
                            },
                        },
                        () => {
                            this.setState({
                                loading: false,
                            });
                        },
                    );
                } else {
                    this.setState(
                        {
                            moreData: nextNewsData,
                            pagination: {
                                current: this.state.pagination.current + 1,
                                pageSize: 24,
                            },
                            showloadMore: false,
                        },
                        () => {
                            this.setState({
                                loading: false,
                            });
                        },
                    );
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    // 处理跳转链接
    formatLink(item) {
        let url = '';

        if (item.base62Id) {
            url = `//v.ifeng.com/c/${item.base62Id}`;
        } else if (item.url) {
            url = item.url;
        } else {
            url = '';
        }

        return url;
    }

    render() {
        // console.log(this.props.content);
        const { content, ad } = this.props;
        const { initData, showloadMore, moreData, loading, playNum } = this.state;

        // 卡片模板
        const listItem = (item, index) => {
            return (
                <div
                    className={`${styles.listItem} clearfix`}
                    key={item.guid}
                    style={{ marginRight: (index + 1) % 3 === 0 ? 0 : 20 }}
                    data-index={index}
                    data-guid={item.guid}>
                    <a href={this.formatLink(item)} target="_blank">
                        <div className={styles.listimg}>
                            {item.posterUrl && (
                                <img src={item.posterUrl ? getImage(item.posterUrl, 320, 180) : ''} alt={item.title} />
                            )}
                            <i />
                            <em className={styles.playNum}>{playNum[item.guid]}</em>
                            <span>{formatVideoDuration(item.duration)}</span>
                        </div>
                        <h3>{item.title}</h3>
                    </a>
                    <div className={styles.listinfo}>
                        <em>
                            <img src="http://p1.ifengimg.com/a/2016/1129/25_25.jpg" />
                            <i>{item.columnName}</i>
                        </em>
                        <span className={styles.upTime}>{item.newsTime}</span>
                    </div>
                </div>
            );
        };

        // 将首屏数据切分成每部分6条
        const firstPageItem = curIndex => {
            if (initData && initData.slice(curIndex * 6, curIndex * 6 + 6).length > 0) {
                const data = initData.slice(curIndex * 6, curIndex * 6 + 6);

                // console.log(data);
                return (
                    <div className={styles.firstPageItem}>
                        {data.map((item, index) => {
                            return listItem(item, index);
                        })}
                    </div>
                );
            } else {
                return null;
            }
        };

        // console.log(ad);

        return (
            <Fragment>
                <div className={styles.content}>
                    {content && content.length > 0 ? (
                        <Fragment>
                            {firstPageItem(0)}
                            {/* 硬广通栏 */}
                            <div className={styles.adBox}>
                                <Ad content={ad.banner01Ad} />
                            </div>
                            {firstPageItem(1)}
                            <div className={styles.adBox}>
                                <Ad content={ad.banner02Ad} />
                            </div>
                            {firstPageItem(2)}
                            <div className={styles.adBox}>
                                <Ad content={ad.banner03Ad} />
                            </div>
                            {firstPageItem(3)}
                            <div className="clearfix">
                                {moreData
                                    ? moreData.map((item, index) => {
                                          return listItem(item, index);
                                      })
                                    : null}
                            </div>
                            {showloadMore ? (
                                <div className={styles.loadMore} onClick={this.handleClickLoadMore}>
                                    <span className={loading ? styles.loading : ''}>加载更多</span>
                                </div>
                            ) : null}
                        </Fragment>
                    ) : (
                        <div className={styles.noData}>暂无数据</div>
                    )}
                </div>
            </Fragment>
        );
    }
}

export default Content;
